import { AbstractFormFragment } from "@components/form/AbstractFormFragment";
import { isMobile } from "@utils/deviceCapabilities";
import CustomSelect  from "./custom-select";

const selectors = {
  select: "select.select",
};

const classes = {
  mobileSelect: "mobile-select",
};

export class DropdownFormFragment extends AbstractFormFragment {
  private select: HTMLSelectElement;
  private selectContainer: HTMLDivElement;

  static getCssClassName() {
    return "comp-form-dropdown";
  }

  initializeNode() {
    if (!isMobile()) {
      this.select = this.node.querySelector(selectors.select);
      this.selectContainer = this.node.querySelector(".select-container");

      this.selectContainer.classList.remove(classes.mobileSelect);

      this.select.style.display = "none";
      new CustomSelect(this.select, this.selectContainer);
    }
    return this;
  }

  hasValue() {
    return true;
  }

  attachChangeListener(_callback: () => void) {
    // ignore as hasValue is always true.
    return this;
  }
}
